import { render, staticRenderFns } from "./DocumentSearch.vue?vue&type=template&id=683b0794&scoped=true&"
import script from "./DocumentSearch.vue?vue&type=script&lang=js&"
export * from "./DocumentSearch.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSearch.vue?vue&type=style&index=0&id=683b0794&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683b0794",
  null
  
)

export default component.exports